import React from 'react';
import Reveal from './atoms/reveal';

const QUALIFICATIONS = [
    {
        title: 'ITパスポート',
        href: null,
        lines: ['情報系初級国家資格'],
    },
    {
        title: 'python3エンジニア認定基礎試験',
        href: 'https://qiita.com/koneko59/items/7cabfa03ade22454b0ac',
        lines: ['情報系初級国家資格', '詳しくは合格記事を参照ください'],
    },
];

function Qualifications() {
    return (
        <section id="qualifications" className="home-section parallax text-center py-10" data-stellar-background-ratio="0.5">
            <div className="flex items-center justify-center py-5">
                <div className="container relative z-30">
                    <Reveal className="section-heading text-center">
                        <h2 className="text-4xl text-center font-semibold pb-3">Qualifications</h2>
                    </Reveal>
                    <Reveal delay={100}>
                        <h3 className="text-2xl text-center font-semibold pb-6">保有する資格の一覧です</h3>
                    </Reveal>
                    <div className="grid gap-3 grid-flow-row-dense grid-cols-3 justify-center xl:px-40 px-10">
                        {QUALIFICATIONS.map((q, i) => {
                            const inner = (
                                <div className="flex flex-col justify-between p-4 leading-normal">
                                    <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900">{q.title}</h5>
                                    {q.lines.map((line) => (
                                        <p key={line} className="mb-3 font-normal text-gray-700">{line}</p>
                                    ))}
                                </div>
                            );
                            const cardClass = 'bounce-hover h-full flex flex-col items-center bg-white border border-gray-200 rounded-lg shadow hover:shadow-xl';

                            return (
                                <Reveal
                                    key={q.title}
                                    variant="scale"
                                    delay={i * 120}
                                    className="col-span-3 lg:col-span-1"
                                >
                                    {q.href ? (
                                        <a href={q.href} target="_blank" rel="noopener noreferrer" className={cardClass}>
                                            {inner}
                                        </a>
                                    ) : (
                                        <div className={cardClass}>{inner}</div>
                                    )}
                                </Reveal>
                            );
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Qualifications;
